import NavigationIcon from "@mui/icons-material/Navigation";
import PinDropIcon from "@mui/icons-material/PinDrop";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { DateTime } from "luxon";

export function VisitorInvite({ data: booking, addToTrybzLink }) {
  const {
    communityName,
    invitedBy,
    qrImageUrl,
    passcode,
    accessType,
    location,
  } = booking;

  const startDate = DateTime.fromISO(booking.startDate, { setZone: true });
  const endDate = DateTime.fromISO(booking.endDate, { setZone: true });

  const mapPinLink = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`;
  const mapDirectionsLink = `https://www.google.com/maps/dir/?api=1&destination=${location.latitude},${location.longitude}`;

  return (
    <div className="tw-grid tw-h-screen tw-overflow-auto">
      <div className="tw-flex tw-flex-col">
        <div
          className="tw-grid"
          style={{
            backgroundColor: "#2032D1",
            backgroundImage:
              'url("https://satrbyzstage.blob.core.windows.net/trbyzstage/images/hexa_spiral.png")',
            backgroundSize: "cover",
          }}
        >
          <div className="tw-mx-auto tw-flex tw-w-full tw-max-w-[700px] tw-flex-col tw-items-start tw-gap-2 tw-p-5 tw-text-white">
            <img
              alt="logo"
              src="https://satrbyzstage.blob.core.windows.net/trbyzstage/images/logo.png"
              className="tw-w-12"
            />
            <span className="tw-mt-5 tw-text-sm tw-font-light">
              {startDate.toLocaleString(DateTime.DATE_FULL)}
            </span>
            <h1 className="tw-text-4xl tw-font-normal tw-text-white">
              Invitation to visit {communityName}
            </h1>
          </div>
        </div>

        <div className="bg-[#F3F3F3] tw-grid">
          <div className="tw-mx-auto tw-flex tw-max-w-[700px] tw-flex-col tw-gap-5 tw-p-5">
            <p className="tw-m-0">
              You have been invited to visit {communityName} by {invitedBy}.
              Below are all the necessary information about your visit
              invitation and security verification check.
            </p>

            <div
              className="border-t-[#2032D1] tw-flex tw-flex-col tw-overflow-hidden tw-rounded-bl-lg tw-rounded-br-lg tw-border-t-2 tw-bg-white tw-shadow"
              style={{ borderTopStyle: "solid" }}
            >
              <img
                alt="qr code"
                src={qrImageUrl}
                className="tw-mx-auto tw-my-12"
                style={{ width: 200, height: 200 }}
              />

              <div className="gap-[1px] bg-[#F3F3F3] tw-grid tw-grid-cols-2">
                <div className="tw-flex tw-flex-col tw-bg-white tw-p-3 tw-font-normal">
                  <span className="tw-text-sm">Visit Date:</span>
                  <span className="tw-text-2xl tw-font-medium">
                    {startDate.toLocaleString(DateTime.DATE_FULL)}
                  </span>
                  <span className="tw-text-sm">
                    {startDate.toLocaleString({
                      hour: "numeric",
                      hourCycle: "h12",
                      minute: "2-digit",
                      timeZoneName: "long",
                    })}
                  </span>
                </div>

                <div className="tw-flex tw-flex-col tw-bg-white tw-p-3 tw-text-right tw-font-normal">
                  <span className="tw-text-sm">Till:</span>
                  <span className="tw-text-2xl tw-font-medium">
                    {endDate.toLocaleString(DateTime.DATE_FULL)}
                  </span>
                  <span className="tw-text-sm">
                    {endDate.toLocaleString({
                      hour: "numeric",
                      hourCycle: "h12",
                      minute: "2-digit",
                      timeZoneName: "long",
                    })}
                  </span>
                </div>

                <div className="tw-col-span-2 tw-flex tw-flex-col tw-bg-white tw-p-3 tw-font-normal">
                  <span className="tw-text-sm">Visiting Address</span>
                  <span className="tw-text-xl tw-font-medium">
                    {location.address}
                  </span>
                  <span className="tw-text-sm">{communityName}</span>
                </div>

                <div className="tw-flex tw-flex-col tw-bg-white tw-p-3 tw-font-normal">
                  <span className="tw-text-sm">Unique Passcode</span>
                  <span className="tw-text-xl tw-font-medium tw-text-[#2032D1]">
                    {passcode}
                  </span>
                </div>

                <div className="tw-flex tw-flex-col tw-bg-white tw-p-3 tw-text-right tw-font-normal">
                  <span className="tw-text-sm">Access Type</span>
                  <span className="tw-text-xl tw-font-medium">
                    {accessType}
                  </span>
                </div>
              </div>
            </div>

            <div className="gap-[1px] tw-grid tw-h-24 tw-grid-cols-3 tw-overflow-hidden tw-rounded-lg tw-shadow">
              <a
                href={mapPinLink}
                target="_blank"
                rel="noreferrer"
                className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-bg-white tw-text-center"
              >
                <PinDropIcon fontSize="large" htmlColor="#2032D1" />
                <span>Location</span>
              </a>

              <a
                href={mapDirectionsLink}
                target="_blank"
                rel="noreferrer"
                className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-bg-white tw-text-center"
              >
                <NavigationIcon fontSize="large" htmlColor="#2032D1" />
                <span>Get Directions</span>
              </a>

              <a
                href={addToTrybzLink}
                className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-bg-white tw-text-center"
              >
                <PlaylistAddIcon fontSize="large" htmlColor="#2032D1" />
                <span>Add to Trybz</span>
              </a>
            </div>

            <p className="tw-m-0">
              Please note that {communityName} has strict security measures in
              place to ensure the safety and privacy of our residents. We
              appreciate your cooperation in following these procedures.
              <br />
              <br />
              Thank you for your cooperation, and we look forward to your visit.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
